"use client";

import React, { useCallback, useRef } from "react";
import Image from "next/image";
import { SanityVideoPlayer } from "@/components/ui/SanityVideoPlayer";
import { MediaPlayerInstance } from "@vidstack/react";
import { IMuxVideoPlayer } from "@/sanity/globals/VideoPlayer";

import playBtnImg from "@/public/global/play-btn.svg";

export default function Video({ videoData }: { videoData: IMuxVideoPlayer }) {
  const videoRef = useRef<MediaPlayerInstance | any>(undefined);
  const playBtnRef = useRef<HTMLDivElement | any>(undefined);

  const hidePlayBtn = useCallback(() => {
    playBtnRef.current.classList.add("opacity-0");
    playBtnRef.current.classList.add("pointer-events-none");
    playBtnRef.current.classList.remove("opacity-80");
  }, []);

  const showPlayBtn = useCallback(() => {
    playBtnRef.current.classList.add("opacity-80");
    playBtnRef.current.classList.remove("pointer-events-none");
    playBtnRef.current.classList.remove("opacity-0");
  }, []);

  const toggleVideoPlayPause = useCallback(() => {
    if (videoRef.current?.paused) {
      videoRef.current?.play();
      hidePlayBtn();
    } else {
      videoRef.current?.pause();
      showPlayBtn();
    }
  }, [hidePlayBtn, showPlayBtn]);

  return (
    <div
      onClick={() => toggleVideoPlayPause()}
      className="w-full h-full min-h-full rounded-[1.5rem] video-with-shadow relative overflow-clip"
    >
      <SanityVideoPlayer
        ref={videoRef}
        playsinline={true}
        className="!w-full"
        playerData={videoData}
        onPlay={() => hidePlayBtn()}
        onPause={() => showPlayBtn()}
      />
      <Image
        ref={playBtnRef}
        src={playBtnImg}
        alt="Play button"
        className="hidden lg:block absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 w-[10rem] h-[10rem] cursor-pointer opacity-80"
      />
    </div>
  );
}
